import React, { useEffect, useState } from 'react'
import NavBar from '../Component/NavBarFooter/NavBar'
import Footer from '../Component/NavBarFooter/Footer'
import { useParams } from 'react-router-dom'
import { useAuth } from '../Context/ContextProvider'
import Content from '../Component/NewsDetail/Content'

function NewsDetail() {
    const {id}=useParams()
    const {getNewsDetails}=useAuth()
    const [newsDetail, setNewsDetail] = useState(null)
    useEffect(()=>{
        const fetchNewsDetail=async()=>{
            const resp=await getNewsDetails(id)
            if(resp.success){
                setNewsDetail(resp.data)
            }
        }
        fetchNewsDetail()
    },[id])
  return (
    <div>
        <NavBar/>
        <Content newsDetail={newsDetail?.news}/>
        <Footer/>
    </div>
  )
}

export default NewsDetail